<template>
  <div class="platform-layout">
    <v-navigation-drawer app v-model="drawer" color="#1a237e" dark>
      <v-list dense nav>
        <v-list-item class="px-2 mb-2">
          <v-list-item-title class="text-h6 font-weight-bold white--text">
            iTPV Platform
          </v-list-item-title>
        </v-list-item>

        <v-list-item
          v-for="item in menuItems"
          :key="item.title"
          :to="item.route"
          link
          active-class="indigo lighten-2"
        >
          <v-list-item-icon>
            <v-icon>{{ item.icon }}</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>{{ item.title }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>

      <template v-slot:append>
        <v-list dense nav>
          <v-list-item @click="logout" link>
            <v-list-item-icon>
              <v-icon>mdi-logout</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>Cerrar sesión</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list>
      </template>
    </v-navigation-drawer>

    <v-app-bar app color="white" flat class="border-bottom">
      <v-app-bar-nav-icon @click="drawer = !drawer" />
      <v-toolbar-title class="text-subtitle-1 grey--text text--darken-2">
        Administración SaaS
      </v-toolbar-title>
      <v-spacer />
      <span class="mr-4 text-caption grey--text">{{ userName }}</span>
    </v-app-bar>

    <v-main class="grey lighten-4">
      <router-view />
    </v-main>
  </div>
</template>

<script>
const AUTH_KEYS = ['token', 'userRole', 'userId', 'userName', 'mustChangePassword'];

export default {
  name: 'PlatformLayout',
  data() {
    return {
      drawer: true,
      userName: localStorage.getItem('userName'),
      menuItems: [
        { title: 'Dashboard', icon: 'mdi-view-dashboard-outline', route: '/platform/dashboard' },
        { title: 'Negocios', icon: 'mdi-domain', route: '/platform/businesses' },
      ],
    };
  },
  created() {
    if (localStorage.getItem('userRole') !== 'super_admin') {
      this.$router.replace('/dashboard');
    }
  },
  methods: {
    logout() {
      AUTH_KEYS.forEach((key) => localStorage.removeItem(key));
      this.$router.push('/login');
    },
  },
};
</script>

<style scoped>
.border-bottom {
  border-bottom: 1px solid #e0e0e0 !important;
}

.platform-layout {
  display: contents;
}
</style>
